import { render, staticRenderFns } from "./CorporationInfoTab3.vue?vue&type=template&id=02787a38"
import script from "./CorporationInfoTab3.vue?vue&type=script&lang=js"
export * from "./CorporationInfoTab3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02787a38')) {
      api.createRecord('02787a38', component.options)
    } else {
      api.reload('02787a38', component.options)
    }
    module.hot.accept("./CorporationInfoTab3.vue?vue&type=template&id=02787a38", function () {
      api.rerender('02787a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfoTab3.vue"
export default component.exports